export default __webpack_public_path__ + "static/media/lunanube.47cf640b.png";